export type CreateSpecialistPayload = {
  userId: number;
  clinicId: number;

  specialtyId: number;

  fullName: string;
  cpsNumber: string;

  gender?: string | null;
  acceptingNewReferrals?: boolean;

  // Legacy/compat age group field still used by backend SpecialistProfile insert
  ageGroup?: string | null;

  // Availability string saved to SpecialistAvailabilityStatus
  availabilityStatus?: string | null;

  // Mappings
  languageIds?: number[];
  visitTypeIds?: number[];
  coverageTypeIds?: number[];

  hospitalIds?: number[];
  procedureIds?: number[];
  excludedProcedureIds?: number[];

  // Conditions mapping (Accepts true/false in SpecialistConditionMapping)
  primaryConditionIds?: number[];
  excludedConditionIds?: number[];

  // Required investigations mapping (SpecialistRequiredInvestigation)
  requiredInvestigationIds?: number[];

  // Wait time snapshot (WaitTimeSnapshot)
  routineWaitWeeks?: number | null;
  urgentWaitWeeks?: number | null;

  // NEW: referral method mapping (ReferralMethod -> SpecialistReferralMethod)
  referralMethodCodes?: string[];

  // Notes
  otherNotes?: string | null;
};

export type CreateSpecialistResponse = {
  message?: string;
  specialistId?: number;
  specialist?: any;
  success?: boolean;
  error?: string;
  details?: any;
};

export async function createSpecialistProfile(
  payload: CreateSpecialistPayload
): Promise<CreateSpecialistResponse> {
  const res = await fetch("/api/specialists", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });

  // If backend returns non-JSON, still show something meaningful
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  if (!res.ok) {
    const errBody = isJson ? await res.json().catch(() => null) : await res.text().catch(() => "");
    const msg =
      (errBody && (errBody.error || errBody.message)) ||
      (typeof errBody === "string" && errBody) ||
      `Failed to create specialist profile (status ${res.status}).`;
    throw new Error(msg);
  }

  return isJson ? await res.json() : { success: true };
}
